<template>
  <div style="padding: 0 10px">
    <div style="text-align: left">
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
        @keydown.native.enter="submit"
      >
        <el-form-item label="容器编号">
          <el-input
            maxlength="50"
            placeholder="请输入"
            v-model="formInline.containerCode"
            clearable
            @clear="getList"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select
            placeholder="任务状态"
            @change="submit"
            v-model="formInline.bizStatus"
          >
            <el-option label="全部" :value="undefined"></el-option>
            <el-option
              v-for="i in status"
              :label="i.label"
              :value="i.value"
              :key="i.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="容器商品">
          <el-select
            placeholder="容器商品"
            @change="submit"
            v-model="formInline.productStatus"
          >
            <el-option label="全部" :value="0"></el-option>
            <el-option label="无商品" :value="2"></el-option>
            <el-option label="有商品" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="容器类型">
          <el-select
            placeholder="容器类型"
            @change="submit"
            v-model="formInline.containerType"
          >
            <el-option label="全部" :value="undefined"></el-option>
            <el-option label="拣货容器" :value="1"></el-option>
            <el-option label="分拣容器" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button style="" type="primary" @click="submit">查询</el-button>
          <el-button style="margin-left: 10px" @click="rest">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="text-align: left; margin-bottom: 10px">
      <el-button type="primary" @click="toCreateContainer">新建容器</el-button>
      <el-button type="primary" @click="batchPrint(rows)" :disabled="!rows.length">批量打印</el-button>
    </div>
    <WmsTable
      :columns="columns"
      :dataSource="dataSource"
      @pageChange="pageChangeCall"
      :hasHeader="false"
      :isPagination="query"
      :isRowSelection="true"
      @selectChange="selectChange"
      rowKey="containerCode"
    >
      <div class="productAmount" slot="productAmount" slot-scope="{ record }">
        <span
          class="btn"
          @click="checkProduct(record)"
          v-if="record.productAmount"
          >{{ record.productAmount }}</span
        >
        <span v-else>-</span>
      </div>
      <div class="action" slot="action" slot-scope="{ record }">
        <span
          type="text"
          :class="{ active: record.status, disabled: !record.status }"
          @click="toOpen(record)"
          >开启</span
        >
        <span
          type="text"
          :class="{ active: !record.status, disabled: record.status }"
          @click="toClose(record)"
          >丨关闭</span
        >
        <span type="text" class="active" @click="print(record)">丨打印</span>
        <span type="text" class="active" @click="printSon(record)" v-if="record.containerType == 2"
          >丨打印子容器</span
        >
      </div>
    </WmsTable>
    <createContainer ref="createContainer" @refresh="getList"></createContainer>
    <el-dialog
      title="容器商品"
      :visible.sync="containerProductsVisible"
      width="900px"
      :close-on-click-modal="false"
    >
      <WmsTable
        :hasHeader="false"
        :isPagination="false"
        :columns="productColumns"
        :dataSource="containerProductList"
        @pageChange="productPageCall"
        :scrollY="800"
      >
        <ImgView
          slot="productImageUrl"
          slot-scope="{ text, record, index }"
          :src="text"
          width="40"
          height="40"
          v-if="text"
        />
      </WmsTable>
    </el-dialog>
  </div>
</template>

<script>
import WmsTable from "@/components/WmsTable";
import ImgView from "@/components/ImgView";
import createContainer from "./components/createContainer.vue";
import { columns, productColumns, statsList } from "./data";
import { templatePrintById } from "@/utils/print"
import {
  containerPage,
  containerOpen,
  containerClose,
  containerProducts,
  getChildContainers
} from "@/apis/configure";
export default {
  title: "容器列表",
  name: "container",
  components: { WmsTable, createContainer, ImgView },
  props: {},
  data() {
    return {
      formInline: {},
      columns,
      productColumns,
      status: statsList(),
      dataSource: [],
      query: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      containerProductsVisible: false,
      containerProductList: [],
      rows: []
    };
  },
  created() {},
  mounted() {
    this.getList();
  },
  methods: {
    submit() {
      this.query.current = 1;
      this.getList();
    },
    rest() {
      this.date = null;
      Object.keys(this.formInline).forEach((i) => {
        this.formInline[i] = undefined;
      });
      this.query = {
        current: 1,
        pageSize: 10,
        total: 0,
      };
      this.getList();
    },
    pageChangeCall(payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getList();
    },
    getList() {
      containerPage({
        pageNum: this.query.current,
        pageSize: this.query.pageSize,
        ...this.formInline,
      }).then((res) => {
        this.dataSource = res.data.records;
        this.query.total = res.data.total;
      });
    },
    toCreateContainer() {
      this.$refs.createContainer.open();
    },
    toOpen(r) {
      containerOpen({ containerCode: r.containerCode }).then((res) => {
        if (res.code == 0) {
          this.$message.success("开启成功");
          this.getList();
        }
      });
    },
    toClose(r) {
      containerClose({ containerCode: r.containerCode }).then((res) => {
        if (res.code == 0) {
          this.$message.success("关闭成功");
          this.getList();
        }
      });
    },
    checkProduct(r) {
      this.productContainerCode = r.containerCode;
      containerProducts({
        containerCode: this.productContainerCode,
      }).then((res) => {
        this.containerProductList = res.data;
        this.containerProductsVisible = true;
      });
    },
    productPageCall(payload) {
      const { current, pageSize } = payload;
      this.query_products.current = current;
      this.query_products.pageSize = pageSize;
      this.checkProduct();
    },
    print(r) {
      this.$printContainer([{
          ...r,
          gridCode: r.containerCode
      }]).catch((res) => {
        templatePrintById(3,[{
          ...r,
          gridCode: r.containerCode
        }]);
      });
    },
    batchPrint(arr) {
      const data = arr.map(v => {
        return {
          ...v,
          gridCode: v.containerCode
        }
      })
      this.$printContainer(data).catch((res) => {
        templatePrintById(3,data);
      });
    },
    printSon(r){
      getChildContainers({
        containerCode: r.containerCode
      }).then(res=> {
        this.batchPrint(res.data)
      })
    },
    selectChange(rows){
      this.rows = rows
    }
  },
};
</script>

<style scoped lang="less">
.action {
  span {
    cursor: pointer;
  }
  .active {
    color: #409eff;
  }
  .disabled {
    color: #c7c7c7;
    cursor: not-allowed;
  }
}

.productAmount {
  .btn {
    color: #409eff;
    cursor: pointer;
  }
}
</style>
